"use strict";
/**
 * @file 缩放控件
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Control_1 = tslib_1.__importDefault(require("./Control"));
/**
 * 缩放控件，默认位于地图右下角
 * @visibleName ZoomControl 缩放控件
 */
var ZoomControl = /** @class */ (function (_super) {
    tslib_1.__extends(ZoomControl, _super);
    function ZoomControl(props) {
        return _super.call(this, props) || this;
    }
    ZoomControl.prototype.getControl = function () {
        return new BMapGL.ZoomControl(this.getOptions());
    };
    ZoomControl.prototype.render = function () {
        return null;
    };
    return ZoomControl;
}(Control_1.default));
exports.default = ZoomControl;
